/**
 * Утилита для управления версиями локальных данных
 * Автоматически очищает устаревшие данные после обновлений приложения
 */

// Текущая версия данных - обновляйте при изменениях схемы данных
const CURRENT_DATA_VERSION = "1.3.0"; // Обновлено для исправления анонимных сессий
const VERSION_KEY = "dataVersion";

/**
 * Проверяет версию данных и очищает устаревшие данные при необходимости
 */
export function checkAndCleanObsoleteData(): void {
  try {
    const storedVersion = localStorage.getItem(VERSION_KEY);

    if (storedVersion !== CURRENT_DATA_VERSION) {
      // КРИТИЧНО: Сохраняем согласие на cookies перед очисткой
      const consent = localStorage.getItem("lingoshade_consent");
      const deviceId = localStorage.getItem("lingoshade_device_id");

      // Список ключей, которые нужно очистить при обновлении версии
      const keysToClean = [
        // Auth данные
        "user",
        "token",
        "anonymousSession",
        "hasAnonymousSession",

        // Profile данные
        "profileData",
        "userProfile",

        // Cache данные
        "textCache",
        "audioCache",
        "apiCache",

        // Redux persist данные
        "persist:root",
        "persist:auth",
        "persist:profile",

        // Другие временные данные
        "lastActivity",
        "tutorialCompleted",
        "preferences",
      ];

      // Очищаем устаревшие данные
      keysToClean.forEach((key) => {
        localStorage.removeItem(key);
      });

      // Также очищаем sessionStorage
      sessionStorage.clear();

      // Обновляем версию
      localStorage.setItem(VERSION_KEY, CURRENT_DATA_VERSION);

      // КРИТИЧНО: Восстанавливаем согласие на cookies
      if (consent) {
        localStorage.setItem("lingoshade_consent", consent);
      }
      if (deviceId) {
        localStorage.setItem("lingoshade_device_id", deviceId);
      }
    }
  } catch {
    // КРИТИЧНО: Сохраняем согласие даже при ошибке
    const consent = localStorage.getItem("lingoshade_consent");
    const deviceId = localStorage.getItem("lingoshade_device_id");

    // В случае ошибки, полностью очищаем localStorage для безопасности
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem(VERSION_KEY, CURRENT_DATA_VERSION);

    // КРИТИЧНО: Восстанавливаем согласие на cookies
    if (consent) {
      localStorage.setItem("lingoshade_consent", consent);
    }
    if (deviceId) {
      localStorage.setItem("lingoshade_device_id", deviceId);
    }
  }
}

/**
 * Принудительно очищает все данные (для использования в крайних случаях)
 * КРИТИЧНО: Всегда сохраняет согласие на cookies!
 */
export function forceCleanAllData(): void {
  // КРИТИЧНО: Сохраняем согласие на cookies перед очисткой
  const consent = localStorage.getItem("lingoshade_consent");
  const deviceId = localStorage.getItem("lingoshade_device_id");

  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem(VERSION_KEY, CURRENT_DATA_VERSION);

  // КРИТИЧНО: Восстанавливаем согласие на cookies
  if (consent) {
    localStorage.setItem("lingoshade_consent", consent);
  }
  if (deviceId) {
    localStorage.setItem("lingoshade_device_id", deviceId);
  }
}

/**
 * Получает текущую версию данных
 */
export function getCurrentDataVersion(): string {
  return CURRENT_DATA_VERSION;
}

/**
 * Проверяет, совместимы ли данные с текущей версией
 */
export function isDataCompatible(): boolean {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  return storedVersion === CURRENT_DATA_VERSION;
}
